import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b8f7d88"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nav_title_wrap" }
const _hoisted_2 = {
  key: 0,
  class: "nav_title_wrap"
}
const _hoisted_3 = {
  key: 0,
  class: "nav_title_wrap_txt nav_title_wrap_subtitle"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "nav_title_wrap_subtitle nav_title_wrap_tab" }
const _hoisted_6 = {
  key: 0,
  class: "nav_btn_wrap"
}
const _hoisted_7 = { class: "popover_box" }
const _hoisted_8 = { class: "popover_box_top" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "popover_box_top_line" }, "电脑观看", -1))
const _hoisted_10 = { class: "popover_box_top_lines" }
const _hoisted_11 = ["data-clipboard-text"]
const _hoisted_12 = { class: "flex" }
const _hoisted_13 = { class: "popover_code_box" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "popover_box_top_line" }, "手机扫码观看", -1))
const _hoisted_15 = { class: "flex" }
const _hoisted_16 = { class: "" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "popover_code_but" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mod_nav_btn_title" }, "预览", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mod_nav_btn_title" }, "退出", -1))
const _hoisted_21 = { key: 1 }
const _hoisted_22 = {
  key: 0,
  class: "nav_btn_wrap"
}
const _hoisted_23 = { class: "nav_ninetyNine" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "99元开播", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mod_nav_btn_title" }, "新建直播", -1))
const _hoisted_26 = ["src"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mod_nav_btn_title" }, "预览", -1))

import { useRoute, useRouter } from 'vue-router';
import { Breadcrumb, Popover, Space, Select, message, Modal } from 'ant-design-vue';
import { computed, withDefaults, useSlots, inject, ref, defineAsyncComponent } from 'vue';
import LiveTab from '@/components/liveItem/LiveTab.vue';
import { StudioLanguage, StudioLanguageClass, StudioStream } from '@/store/modules/live/types';
import AppLink from '@/components/AppLink.vue';
import { getCertificationStatus, getCertificationView, getExamine, removeToken } from '@/plugins/cookie';
import CModal from '@/components/CModal.vue';
import emitter from '@/utils/mitt';
import { useLiveStore } from '@/pinia/live';
import { useDebounce } from '@/hooks/useDebounce';
import http from '@/api/conentCenter/communal';
import { useHomeStore } from '@/pinia/home';
import { LinkOutlined } from '@ant-design/icons-vue';
import ClipboardJS from 'clipboard';
import { useStore } from 'vuex';

interface PropType {
  showliveInfo?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Header',
  props: {
    showliveInfo: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { showliveInfo: boolean };

const BeautifyCode = defineAsyncComponent(() => import('@/views/dataCenter/BeautifyCode.vue'));
const VideoeEmbed = defineAsyncComponent(() => import('@/views/dataCenter/VideoeEmbed.vue'));
const mediaRef = ref();
const aBreadcrumb = Breadcrumb;
const aSelect = Select;
const aSelectOption = Select.Option;
const aSpace = Space;
const aBreadcrumbItem = Breadcrumb.Item;
const aPopover = Popover;
const aModal = Modal;
const route = useRoute();
const isVisible = ref<boolean>(false);
// 去认证
const toCertify = () => {
  if (getCertificationView() == 0 && getCertificationStatus() == 0) {
    message.error('您的上级账号未认证，无法新建直播！');
  } else if (getCertificationStatus() == 0) {
    isVisible.value = true;
    return;
  } else if (getCertificationStatus() == 2) {
    router.push({ path: '/newlive' });
  } else {
    router.push({ path: '/personal/set/certification' });
  }
  // getCertificationStatus() != 2 ? (isVisible.value = true) : router.push({ path: '/newlive', params: { title: true } });
};
const isopenDelModal = () => {
  isVisible.value = !isVisible.value;
};

const liveStore = useLiveStore();
const liveInfo = computed(() => liveStore.liveInfo);

// 公共状态是否有直播间数据的状态
const liveInfoVisible = computed(() => (props.showliveInfo && route.name !== 'Home') || liveInfo.value.id);

const homeStore = useHomeStore();
const ninePMTRole = computed(() => homeStore.funcData?.ninetyPromotion); // 99元开播权限
const solts = useSlots();
const liveStream = computed(() => {
  let Payment: StudioLanguageClass[] = [
    {
      id: liveInfo.value.studio_pid ?? 0,
      label: '全局设置',
      img: process.env.VUE_APP_OTHER_LINK+'/earth.svg',
    },
  ];
  if (liveInfo.value.mode === 5 && liveInfo.value.studio_language) {
    liveInfo.value.studio_language.forEach((e: StudioLanguage) => {
      Payment.push(new StudioLanguageClass(e));
    });
  } else if (liveInfo.value.mode === 4 && liveInfo.value.stream_list) {
    liveInfo.value.stream_list.forEach((e: StudioStream) => {
      Payment.push(new StudioLanguageClass(e));
    });
  }
  return Payment;
});

const router = useRouter();
const getMenu: any = inject('getmenu');
const partialRefresh: any = inject('reload');
// 切换频道
const handSwitch = async () => {
  getMenu(route, undefined, liveInfo.value.id); // 更新路由菜单
  await router.replace({ name: route.name as string, params: { studioId: liveInfo.value.id } });
  router.push({ name: 'BroadCastControl', params: { studioId: liveInfo.value.id } });
  partialRefresh(); // 局部首页内的组件信息
};

// 门户返回
const returnGateway = () => {
  router.push({ path: '/site' });
};
// 门户保存
const preserveGateway = useDebounce(() => {
  emitter.emit('crumb', '保存');
});
const title = ref(); //门户名称
emitter.on('title', (res) => {
  title.value = res;
});
// 门户预览
const preserve = ref({ qr_code: '', share_url: '' });
const gatewayPreview = () => {
  http
    .getPortalExtensionInfo({
      params: {
        portal_id: route.params.gatewayId,
      },
    })
    .then((res) => {
      preserve.value = {
        qr_code: res.data.data.qr_code,
        share_url: res.data.data.share_url,
      };
    });
};
route.name == 'Decorate' ? gatewayPreview() : '';

const downs = () => {
  window.location.href = liveInfo.value.qr_code_pic;
};

const showVisible = ref(false);
const showModal = () => {
  showVisible.value = !showVisible.value;
};

// 拉流/播放器嵌入
const showEmbed = ref(false);
const openEmbed = () => {
  showEmbed.value = !showEmbed.value;
};

const Copylist = (btns: string) => {
  let ClipboardJSObj = new ClipboardJS(btns);
  ClipboardJSObj.on('success', function (e) {
    message.destroy();
    message.info('复制成功');
    e.clearSelection();
  });
  ClipboardJSObj.on('error', function () {
    message.destroy();
    message.info('复制失败');
  });
};

const onExit = () => {
  //   router.push(getExamine()?.url);
  removeToken();
};
const store = useStore();
const customData = computed(() => store.state.home.customData);
console.log(customData.value.top_logo_url, customData.value.logo_url);
// const logoUrl = computed(() => {
//   return !collapsed.value ? customData.value.top_logo_url : customData.value.logo_url;
// });

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: "navigation",
    ref_key: "mediaRef",
    ref: mediaRef,
    style: _normalizeStyle({ 'border-color': _unref(route).meta.menuType == 'gateway' ? '#DCDFE6' : '' })
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_unref(liveInfoVisible))
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_unref(solts).title)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                  _renderSlot(_ctx.$slots, "title")
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("img", {
              src: _unref(customData).top_logo_url,
              class: "nav_title_wrap_logo nav_title_wrap_tab"
            }, null, 8, _hoisted_4),
            _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(liveInfo).title), 1),
            _createVNode(LiveTab, {
              tabType: "status",
              class: "nav_title_wrap_tab",
              statusType: _unref(liveInfo).status,
              size: "xs"
            }, null, 8, ["statusType"])
          ]))
        : (_openBlock(), _createBlock(_unref(aBreadcrumb), {
            key: 1,
            class: "nav_title_wrap_crumb"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(route).matched, (item, index) => {
                return (_openBlock(), _createBlock(_unref(aBreadcrumbItem), { key: index }, {
                  default: _withCtx(() => [
                    (item.name === _unref(route).name)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(title.value || item.meta.title), 1)
                        ], 64))
                      : (_openBlock(), _createBlock(_component_router_link, {
                          key: 1,
                          to: item.path
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.meta.title), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }))
    ]),
    _createElementVNode("div", null, [
      _renderSlot(_ctx.$slots, "btn", {}, () => [
        (_unref(liveInfoVisible))
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_unref(aPopover), {
                overlayClassName: "live_tipcard",
                getPopupContainer: (triggerNode) => triggerNode.parentNode
              }, {
                content: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _hoisted_9,
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_a_input, {
                          value: _unref(liveInfo).qr_code_url,
                          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_unref(liveInfo).qr_code_url) = $event)),
                          readonly: ""
                        }, {
                          prefix: _withCtx(() => [
                            _createVNode(_unref(LinkOutlined), { class: "popover_box_svg" })
                          ]),
                          addonAfter: _withCtx(() => [
                            _createElementVNode("span", {
                              class: "copy_btn copy",
                              "data-clipboard-text": _unref(liveInfo).qr_code_url,
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (Copylist('.copy_btn')))
                            }, [
                              _createVNode(_component_svg_icon, { "icon-class": "live_url_copy" })
                            ], 8, _hoisted_11)
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_a_button, {
                          type: "primary",
                          href: _unref(liveInfo).qr_code_url,
                          target: "block"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("打开")
                          ]),
                          _: 1
                        }, 8, ["href"]),
                        _createVNode(_component_a_button, { onClick: openEmbed }, {
                          default: _withCtx(() => [
                            _createTextVNode("拉流/播放器嵌入")
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _hoisted_14,
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("img", {
                            src: _unref(liveInfo).qr_code_pic,
                            width: "80",
                            height: "80",
                            alt: ""
                          }, null, 8, _hoisted_17)
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                          _createVNode(_component_a_button, {
                            class: "mod_btn_primary actived",
                            onClick: showModal
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_svg_icon, {
                                "icon-class": "buling_code",
                                style: {"margin-right":"5px"}
                              }),
                              _createTextVNode("美化 ")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_button, {
                            class: "mod_btn_primary actived",
                            onClick: downs
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_svg_icon, {
                                "icon-class": "dow_code",
                                style: {"margin-right":"5px"}
                              }),
                              _createTextVNode("下载")
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ])
                  ])
                ]),
                default: _withCtx(() => [
                  _createVNode(AppLink, {
                    to: _unref(liveInfo).qr_code_url,
                    target: "_block",
                    class: "nav_btn_link"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, { class: "mod_btn_primary actived" }, {
                        icon: _withCtx(() => [
                          _createVNode(_component_svg_icon, { "icon-class": "nav_btn_see" })
                        ]),
                        default: _withCtx(() => [
                          _hoisted_19
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["to"])
                ]),
                _: 1
              }, 8, ["getPopupContainer"]),
              _createVNode(AppLink, {
                to: `${_unref(getExamine)()?.url}`,
                onClick: onExit,
                class: "nav_btn_link"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, { class: "actived" }, {
                    icon: _withCtx(() => [
                      _createVNode(_component_svg_icon, { "icon-class": "examine_quit" })
                    ]),
                    default: _withCtx(() => [
                      _hoisted_20
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["to"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_21, [
              (_unref(ninePMTRole) && _unref(route).meta.menuType !== 'gateway')
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createVNode(_component_router_link, {
                      class: "nav_btn_link",
                      to: { name: 'newLive', params: { title: false } }
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_23, [
                          _hoisted_24,
                          _createVNode(_component_svg_icon, {
                            class: "hot_icon",
                            id: "hotId",
                            "icon-class": "hotIcon"
                          })
                        ])
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (_unref(route).meta.menuType !== 'gateway')
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 1,
                    class: "mod_btn_primary actived crumb",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (toCertify()))
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_component_svg_icon, {
                        class: "mod_nav_btn_icon",
                        "icon-class": "nav_btn_newlive"
                      })
                    ]),
                    default: _withCtx(() => [
                      _hoisted_25
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_unref(route).name == 'Decorate')
                ? (_openBlock(), _createBlock(_unref(aPopover), {
                    key: 2,
                    overlayClassName: "live_tipcard",
                    getPopupContainer: (triggerNode) => triggerNode.parentNode
                  }, {
                    content: _withCtx(() => [
                      _createElementVNode("img", {
                        src: preserve.value.qr_code,
                        width: "66",
                        height: "66",
                        alt: ""
                      }, null, 8, _hoisted_26)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(AppLink, {
                        to: preserve.value.share_url,
                        target: "_block",
                        class: "nav_btn_link"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_button, {
                            class: "gateway_preview actived",
                            type: "text",
                            onClick: gatewayPreview
                          }, {
                            icon: _withCtx(() => [
                              _createVNode(_component_svg_icon, { "icon-class": "nav_btn_see" })
                            ]),
                            default: _withCtx(() => [
                              _hoisted_27
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ]),
                    _: 1
                  }, 8, ["getPopupContainer"]))
                : _createCommentVNode("", true),
              (_unref(route).meta.menuType == 'gateway')
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 3,
                    onClick: returnGateway
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("返回")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_unref(route).name == 'Decorate')
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 4,
                    type: "primary",
                    class: "preserve",
                    onClick: _unref(preserveGateway)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("保存")
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]))
      ])
    ]),
    _createVNode(CModal, {
      visible: isVisible.value,
      close: isopenDelModal,
      centered: ""
    }, null, 8, ["visible"]),
    _createVNode(_unref(aModal), {
      visible: showVisible.value,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((showVisible).value = $event)),
      centered: "",
      width: "850px",
      title: "美化二维码",
      footer: false
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(BeautifyCode))
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_unref(aModal), {
      visible: showEmbed.value,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((showEmbed).value = $event)),
      centered: "",
      width: "580px",
      title: "拉流/播放器嵌入"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(VideoeEmbed))
      ]),
      _: 1
    }, 8, ["visible"])
  ], 4))
}
}

})